import { useState } from 'react'

import SearchResultChoice from './SearchResultChoice'

const SearchResultChoiceList = ({ mapId, group }) => {
  const { id, title, results, showResults } = group
  const [showChoices, setShowChoices] = useState(showResults)

  return (
    <div className="search--choice-type-wrapper">
      <input className="off-the-grid" id={`choice-type-${mapId}-${id}`} type="checkbox" checked={showChoices} onChange={() => setShowChoices(a => !a)} />
      <label className="search--choice-type" htmlFor={`choice-type-${mapId}-${id}`}>{title} <span>({results.length})</span></label>
      <ul className="search--choice-list">
        {results.map((r, i) => <SearchResultChoice key={i} mapId={mapId} item={r} />)}
      </ul>
    </div>
  )
}

export default SearchResultChoiceList